import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class NavigationGuardService {
  hasUnsavedChanges = false;
  saveCallback: (() => Promise<void>) | null = null;

  // Emits the proceed action when user attempts an action while there are unsaved changes
  promptRequested$ = new Subject<() => void>();

  /**
   * Request an action. If the reporting component is active (saveCallback is set),
   * emits on promptRequested$ so it can show the save prompt. Otherwise calls proceedFn immediately.
   */
  requestAction(proceedFn: () => void) {
    if (!this.saveCallback || !this.hasUnsavedChanges) {
      proceedFn();
      return;
    }
    this.promptRequested$.next(proceedFn);
  }

  clearGuard() {
    this.hasUnsavedChanges = false;
    this.saveCallback = null;
  }
}
